// extracted by mini-css-extract-plugin
export default {"Chart":"hu7VhAVKK2miQNygPDAs"};